import React, { useState, useEffect, useRef } from 'react'
import logo from "../assets/image/dp3.png"
import adarsh from "../assets/image/unnamed.gif"
import { NavLink } from 'react-router-dom';

export default function Navbar() {
    
    const [scrolled, setScrolled] = useState(false);
    const [navOverlay, setNavOverlay] = useState({ display: "none" });
    const [isOpen, setIsOpen] = useState(false);
    const [classOne, setClassOne] = useState({transform: "rotate(0)", transformOrigin: "right center"})
    const [classTwo, setClassTwo] = useState({opacity: "1"})
    const [classThree, setClassThree] = useState({transform: "rotate(0)", transformOrigin: "right center"})
    const [mobileNav, setMobileNav] = useState({opacity: "0", zIndex: "-1"})
    const navbarRef = useRef(null);
    const toggleHamb = () => {
        setIsOpen(!isOpen);
        if (!isOpen) {
            setClassOne({transform: "rotate(-45deg)", transformOrigin: "right center"})
            setClassTwo({opacity: "0"});
            setClassThree({transform: "rotate(45deg)", transformOrigin: "right center"})
            document.body.style.overflow = "hidden";
            setNavOverlay({ display: "block" });
            setMobileNav({opacity: "1", zIndex: "10"})
        }
        else {
            setClassOne({transform: "rotate(0)", transformOrigin: "right center"})
            setClassTwo({opacity: "1"});
            setClassThree({transform: "rotate(0)", transformOrigin: "right center"})
            document.body.style.overflow = "auto";
            setNavOverlay({ display: "none" });
            setMobileNav({opacity: "0", zIndex: "-1"})
        }
    }
    const dismissNavPop = () => {
        setClassOne({transform: "rotate(0)", transformOrigin: "right center"})
        setClassTwo({opacity: "1"});
        setClassThree({transform: "rotate(0)", transformOrigin: "right center"})
        document.body.style.overflow = "auto";
        setNavOverlay({ display: "none" });
        document.querySelector(".mobile-screen-nav").style.opacity = "0";
        document.querySelector(".mobile-screen-nav").style.zIndex = "-1";
    }

    useEffect(() => {
        function handleScroll() {
            if (navbarRef.current) {
                const navbarHeight = navbarRef.current.getBoundingClientRect().height;
                if (window.scrollY > navbarHeight) {
                    setScrolled(true);
                } else {
                    setScrolled(false);
                }
            }
        }
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);


    return (
        <>
            <img src={logo} className="bg" alt="logo.png" />
            <div className="container">
            </div>
            <div className="shade">
            </div>
            <nav ref={navbarRef} className={`navbar ${scrolled ? "navbar-fixed" : ""}`}>
                <div className="name">
                    {/* <h1><span>A</span>darsh</h1> */}
                    <div className="img-container">
                        <img className='adarsh-logo' src={adarsh} alt={adarsh}/>
                    </div>
                    <p>Adarsh</p>
                </div>
                <ul>
                    <li><NavLink to="/" activeclassname="is-active" className="line-bottom hom">Home</NavLink></li>
                    <li><NavLink to="/about" activeclassname="is-active" className="line-bottom abo">About</NavLink></li>
                    <li><NavLink to="/resume" activeclassname="is-active" className="line-bottom res">Resume</NavLink></li>
                    <li><NavLink to="/services" activeclassname="is-active" className="line-bottom serv">Services</NavLink></li>
                    <li><NavLink to="/contact" activeclassname="is-active" className="line-bottom cont">Contact Us</NavLink></li>
                </ul>
            </nav>
            <div onClick={toggleHamb} className="hamb" style={{top: (scrolled? '38px':"28px"),right: (scrolled? '55px':"25px")}}>
                <div className="one" style={classOne}></div>
                <div className="two" style={classTwo}></div>
                <div className="three" style={classThree}></div>
            </div>
            <div className="mobile-nav-overlay" style={navOverlay}></div>
            <div className="mobile-screen-nav" style={mobileNav}>
                <ul id='navLinks'>
                    <li><NavLink onClick={dismissNavPop} to="/" activeclassname="is-active" className="line-bottom hom">Home</NavLink></li>
                    <li><NavLink onClick={dismissNavPop} to="/about" activeclassname="is-active" className="line-bottom abo">About</NavLink></li>
                    <li><NavLink onClick={dismissNavPop} to="/resume" activeclassname="is-active" className="line-bottom res">Resume</NavLink></li>
                    <li><NavLink onClick={dismissNavPop} to="/services" activeclassname="is-active" className="line-bottom serv">Services</NavLink></li>
                    <li><NavLink onClick={dismissNavPop} to="/contact" activeclassname="is-active" className="line-bottom cont">Contact Us</NavLink></li>
                </ul>
            </div>
        </>
    )
}
